// api/hooks/jobHooks.js
import { useState, useCallback } from "react";
import { authenticatedRequest, publicRequest } from "../api/clients";
import { ENDPOINTS } from "../api/endpoints";
import axios from "axios";
const API_BASE = process.env.REACT_APP_API_BASE_URL;
// Hook for listing job applications

// Test version of listJobApplications using fetch
export const useListJobApplicationsTest = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [data, setData] = useState(null);

  const listJobApplications = useCallback(async (queries = {}) => {
    try {
      setLoading(true);
      setError(null);

      const url = `${API_BASE}${ENDPOINTS.JOBS.LIST_APPLICATIONS(queries)}`;
      console.log("Test Fetch URL:", url);

      const response = await fetch(url, {
        headers: {
          Accept: "application/json",
          // Add any required headers manually
          // 'Authorization': `Bearer ${localStorage.getItem('jobToken')}`
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const result = await response.json();
      console.log("Test Fetch Response:", result);

      setData(result.data?.results);
      return result.data?.results;
    } catch (err) {
      setError(err.message);
      console.error("Test Fetch Error:", err);
      throw err;
    } finally {
      setLoading(false);
    }
  }, []);

  return { listJobApplications, loading, error, data };
};
export const useListJobApplications = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [data, setData] = useState(null);

  const listJobApplications = useCallback(async (queries = {}) => {
    try {
      setLoading(true);
      setError(null);

      const response = await publicRequest.get(
        ENDPOINTS.JOBS.LIST_APPLICATIONS(queries)
      );
      const result = response.data?.data?.results;

      setData(result);
      return result;
    } catch (err) {
      setError(err.response?.data?.message || err.message);
      throw err;
    } finally {
      setLoading(false);
    }
  }, []);

  return { listJobApplications, loading, error, data };
};

// Hook for getting job applicant by ID
export const useGetJobApplicantById = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [data, setData] = useState(null);

  const getJobApplicantById = useCallback(async (app_id, user_id) => {
    try {
      setLoading(true);
      setError(null);

      const response = await authenticatedRequest.get(
        ENDPOINTS.JOBS.APPLICANT_BY_ID(app_id, user_id)
      );

      setData(response.data?.data);
      return response.data?.data;
    } catch (err) {
      setError(err.response?.data?.message || err.message);
      throw err;
    } finally {
      setLoading(false);
    }
  }, []);

  return { getJobApplicantById, loading, error, data };
};

// Hook for getting job posts
export const useGetJobPosts = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [data, setData] = useState(null);

  const getJobPosts = useCallback(async (queries = {}) => {
    try {
      setLoading(true);
      setError(null);

      const response = await authenticatedRequest.get(
        ENDPOINTS.JOBS.JOB_POSTS(queries)
      );
      const result = response.data?.data?.results;
      setData(result);
      return result;
    } catch (err) {
      setError(err.response?.data?.message || err.message);
      throw err;
    } finally {
      setLoading(false);
    }
  }, []);

  return { getJobPosts, loading, error, data };
};

// Hook for getting job post detail
export const useGetJobPostDetail = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [data, setData] = useState(null);

  const getJobPostDetail = useCallback(async (job_id, user_id) => {
    try {
      setLoading(true);
      setError(null);

      const response = await authenticatedRequest.get(
        ENDPOINTS.JOBS.JOB_POST_DETAIL(job_id, user_id)
      );
      const result = response.data.data;
      setData(result);
      return result;
    } catch (err) {
      setError(err.response?.data?.message || err.message);
      throw err;
    } finally {
      setLoading(false);
    }
  }, []);

  return { getJobPostDetail, loading, error, data };
};

// Hook for getting applicants of individual jobs
export const useGetJobApplicantByJobId = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [data, setData] = useState(null);

  const getJobPostApplicants = useCallback(async (job_id, queries = {}) => {
    try {
      setLoading(true);
      setError(null);

      const response = await authenticatedRequest.get(
        ENDPOINTS.JOBS.JOB_APPLICANTS(job_id, queries)
      );
      const result = response.data.data.results;
      setData(result);
      return result;
    } catch (err) {
      setError(err.response?.data?.message || err.message);
      throw err;
    } finally {
      setLoading(false);
    }
  }, []);

  return { getJobPostApplicants, loading, error, data };
};
export const useDeleteJobPost = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const deleteJobPost = useCallback(async (queries = {}) => {
    try {
      setLoading(true);
      setError(null);

      const response = await authenticatedRequest.delete(
        ENDPOINTS.JOBS.DELETE_JOB_POST(queries)
      );
      const result = response.data;
      return result;
    } catch (err) {
      setError(err.response?.data?.message || err.message);
      throw err;
    } finally {
      setLoading(false);
    }
  }, []);

  return { deleteJobPost, loading, error };
};
export const useDownloadBulkCvs = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const downloadBulk = async (ids) => {
    setLoading(true);
    setError(null);

    try {
      // Make API call with application_ids as query parameter
      const response = await axios({
        method: "GET",
        url: "https://test.youthplus.ng/onboard/download-cv/", // Replace with your actual API endpoint
        params: {
          application_ids: ids, // This will be the comma-separated string
        },
        responseType: "blob", // Important: This tells axios to expect a binary response
        timeout: 300000, // 5 minutes timeout for large zip files

        paramsSerializer: {
          serialize: (params) => {
            // Custom serialization to ensure proper query string format
            const searchParams = new URLSearchParams();
            Object.keys(params).forEach((key) => {
              searchParams.append(key, params[key]);
            });
            return searchParams.toString();
          },
        },
      });

      // Check if response is actually a blob
      if (!(response.data instanceof Blob)) {
        throw new Error("Response is not a valid file");
      }

      // Check if the blob has content
      if (response.data.size === 0) {
        throw new Error("Received empty file");
      }

      return response.data; // Return the blob
    } catch (err) {
      console.error("Bulk download error:", err);

      // Set appropriate error message based on error type
      if (err.code === "ECONNABORTED") {
        setError(new Error("Download timeout. The file might be too large."));
      } else if (err.response?.status === 404) {
        setError(new Error("Download endpoint not found"));
      } else if (err.response?.status === 400) {
        setError(
          new Error("Invalid request. Please check selected applicants.")
        );
      } else if (err.response?.status >= 500) {
        setError(new Error("Server error. Please try again later."));
      } else if (!navigator.onLine) {
        setError(new Error("No internet connection"));
      } else {
        setError(err);
      }

      throw err; // Re-throw so component can handle it
    } finally {
      setLoading(false);
    }
  };

  return {
    downloadBulk,
    loading,
    error,
  };
};

// // Alternative implementation using fetch instead of axios
// export const useDownloadBulkCvsFetch = () => {
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState(null);

//   const downloadBulk = async (ids) => {
//     setLoading(true);
//     setError(null);

//     try {
//       // Properly construct the URL with application_ids parameter
//       const url = new URL('/api/applicants/download-bulk-cvs', window.location.origin);
//       url.searchParams.set('application_ids', ids);

//       console.log('Requesting URL:', url.toString()); // Debug log

//       const response = await fetch(url.toString(), {
//         method: 'GET',
//         headers: {
//           'Accept': 'application/zip, application/octet-stream',
//           // Add authorization headers if needed
//           // 'Authorization': `Bearer ${token}`
//         }
//       });

//       if (!response.ok) {
//         const errorText = await response.text();
//         throw new Error(`HTTP ${response.status}: ${errorText}`);
//       }

//       const blob = await response.blob();

//       if (blob.size === 0) {
//         throw new Error('Received empty file');
//       }

//       return blob;

//     } catch (err) {
//       console.error('Bulk download error:', err);
//       setError(err);
//       throw err;
//     } finally {
//       setLoading(false);
//     }
//   };

//   return {
//     downloadBulk,
//     loading,
//     error
//   };
// };
